// Stacked panel layouts (mirror of backend/layouts.py): rows "/", columns "|", groups "( )"; X = sash, O = fixed.
export const isStacked = (v) => /[/(]/.test(v || "");

export function parseLayout(v) {
  const toks = String(v || "").toUpperCase().replace(/0/g, "O").match(/[OX()|/]/g) || [];
  let pos = 0;
  const peek = () => toks[pos];
  const cell = () => {
    const t = toks[pos++];
    if (t === "X" || t === "O") return ["cell", t];
    if (t === "(") {
      const e = rows();
      if (toks[pos++] !== ")") throw new Error("bad");
      return e;
    }
    throw new Error("bad");
  };
  const seq = (kind, sep, next) => {
    const out = [next()];
    while (peek() === sep) { pos++; out.push(next()); }
    return out.length === 1 ? out[0] : [kind, out];
  };
  const cols = () => seq("cols", "|", cell);
  const rows = () => seq("rows", "/", cols);
  const t = rows();
  if (pos !== toks.length) throw new Error("bad");
  return t;
}

export const layoutText = (t) => (t[0] === "cell" ? t[1] : t[1].map((c) => (c[0] === "cell" || (t[0] === "rows" && c[0] === "cols") ? layoutText(c) : `(${layoutText(c)})`)).join(t[0] === "cols" ? "|" : "/"));
const text = layoutText;

export const cleanStacked = (v) => {
  try { return text(parseLayout(v)); } catch { return null; }
};

export function layoutCells(t, x, y, w, h, widths, heights) {
  if (t[0] === "cell") return [[t[1], x, y, w, h]];
  const kids = t[1];
  const given = t[0] === "cols" ? widths : heights;
  const total = t[0] === "cols" ? w : h;
  const ok = given && given.length === kids.length && given.every(Boolean) && Math.abs(given.reduce((a, b) => a + b, 0) - total) < 0.6;
  const sizes = ok ? given : kids.map(() => total / kids.length);
  const out = [];
  kids.forEach((k, i) => {
    out.push(...(t[0] === "cols" ? layoutCells(k, x, y, sizes[i], h) : layoutCells(k, x, y, w, sizes[i])));
    if (t[0] === "cols") x += sizes[i]; else y += sizes[i];
  });
  return out;
}
